
import React from 'react';
import { DisplaySlide } from '../layout/DisplaySlide';
import { ContentSection } from '../layout/ContentSection';
import { SectionGrid } from '../layout/SectionGrid';
import { AdaptiveText } from '../layout/AdaptiveText';

interface GeneralInfoSlideProps {
  date: string;
  hebrewDate: string;
  parsha?: string;
  omer?: string;
  specialDay?: string;
}

export const GeneralInfoSlide: React.FC<GeneralInfoSlideProps> = ({
  date,
  hebrewDate,
  parsha,
  omer,
  specialDay
}) => {
  return (
    <DisplaySlide background="gradient" padding="lg">
      <div className="h-full flex flex-col justify-center items-center text-center space-y-8">
        {/* Main Date Display */}
        <div className="space-y-4">
          <AdaptiveText baseSize="xl" className="font-frank font-bold text-white text-shadow-lg">
            {hebrewDate}
          </AdaptiveText>
          <AdaptiveText baseSize="lg" className="font-heebo text-white/90 text-shadow-md">
            {date}
          </AdaptiveText>
        </div>

        {/* Special Day */}
        {specialDay && (
          <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border-2 border-white/30">
            <AdaptiveText baseSize="lg" className="font-frank font-bold text-yellow-200 text-shadow-md">
              {specialDay}
            </AdaptiveText>
          </div>
        )}

        {/* Grid of additional info */}
        <SectionGrid columns={2} gap="md" className="w-full max-w-4xl">
          {parsha && (
            <ContentSection title="פרשת השבוע" height="fixed" textSize="md">
              <AdaptiveText baseSize="md" className="font-frank font-bold">
                {parsha}
              </AdaptiveText>
            </ContentSection>
          )}
          
          {omer && (
            <ContentSection title="ספירת העומר" height="fixed" textSize="md">
              <AdaptiveText baseSize="md" className="font-heebo">
                {omer}
              </AdaptiveText>
            </ContentSection>
          )}
        </SectionGrid>
      </div>
    </DisplaySlide>
  );
};
